import React from 'react';

const rootConst = 'AUTH';

export const AUTHENTICATION = `${rootConst}/AUTHENTICATION`;
export const LOGIN = `${rootConst}/LOGIN`;
export const SIGN_UP = `${rootConst}/SIGN_UP`;
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const TOKEN_EXPIRY = 'TOKEN_EXPIRY';
export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
export const GET_NOTIFICATION = 'GET_NOTIFICATION';
export const GET_NOTIFICATION_APPEND = 'GET_NOTIFICATION_APPEND';
export const GET_NEW_NOTIFICATION = 'GET_NEW_NOTIFICATION';
export const PATCH_NOTIFICATION = 'PATCH_NOTIFICATION';
export const POST_MARK_ALL_AS_READ = 'POST_MARK_ALL_AS_READ';
export const PASSWORD_EXPIRED = 'PASSWORD_EXPIRED';
export const SELECT_AUTH_METHOD = 'SELECT_AUTH_METHOD';
export const AUTH_OTP = 'AUTH_OTP';

export const AUTH_TYPE = React.createContext();
export const AUTH_PROFILE = React.createContext();

export const NOTIFICATION_TYPE = {
  // orders
  NEW_ORDER_CREATED: {
    label: 'New Order',
    code: 'order',
  },
  ORDER_CANCELLED: {
    label: 'Order Cancelled',
    code: 'order',
  },
  ORDER_DELIVERED: {
    label: 'Order Delivered',
    code: 'order',
  },
  ORDER_PENDED: {
    label: 'Order Pending',
    code: 'order',
  },
  ORDER_FOR_PICKUP: {
    label: 'Order for Rider Pickup',
    code: 'order',
  },
  ORDER_FOR_REBOOK: {
    label: 'Order for Rebook',
    code: 'order',
  },

  // riders
  RIDER_ACCEPTED: {
    label: 'Rider Accepted',
    code: 'rider',
  },
  RIDER_DELIVERED: {
    label: 'Rider Delivered',
    code: 'rider',
  },
  RIDER_ARRIVED_AT_PICKUP: {
    label: 'Rider Arrived',
    code: 'rider',
  },

  // inventory
  INVENTORY_OUT_OF_STOCK: {
    label: 'Inventory Out of Stock',
    code: 'inventory',
  },
  INVENTORY_LOW_ON_STOCK: {
    label: 'Inventory Low on Stock',
    code: 'inventory',
  },
};

export const NOTIFICATION_TYPE_V2 = {
  // registered
  NEW_RIDER_REGISTERED: {
    label: 'NEW_RIDER_REGISTERED',
    // code: '',
  },
  NEW_VENDOR_REGISTERED: {
    label: 'NEW_VENDOR_REGISTERED',
    // code: '',
  },

  // order
  NEW_ORDER_CREATED: {
    label: 'New Order Created',
    code: 'order',
  },
  ORDER_CANCELLED: {
    label: 'Order Cancelled',
    code: 'order',
  },
  ORDER_DELIVERED: {
    label: 'Order Delivered',
    code: 'order',
  },
  // ORDER_PENDED: {
  //   label: 'Order Pended',
  //   code: 'order',
  // },
  // ORDER_FOR_PICKUP: {
  //   label: 'Order for Pickup',
  //   code: 'order',
  // },
  // ALLOCATING: {
  //   label: 'Allocating',
  //   code: 'order',
  // },
  // IN_TRANSIT: {
  //   label: 'In Transit',
  //   code: 'order',
  // },
  RIDER_CANCELLED: {
    label: 'Rider Cancelled',
    code: 'order',
  },
  // MERCHANT_CANCELLED: {
  //   label: 'Merchant Cancelled',
  //   code: 'order',
  // },
  ORDER_FOR_REBOOK: {
    label: 'Order for Rebook',
    code: 'order',
  },

  // reminder
  ADVANCED_ORDER_REMINDER: {
    label: 'Advance Order Reminder',
    code: 'order',
  },

  // inventory
  INVENTORY_OUT_OF_STOCK: {
    label: 'Inventory Out of Stock',
    code: 'inventory',
  },
  INVENTORY_LOW_ON_STOCK: {
    label: 'Inventory Low on Stock',
    code: 'inventory',
  },
};

export const TAB_OPTS = [
  {
    label: 'Unread',
    value: 'unread',
    filters: {
      new: 1,
    },
  },
  {
    label: 'All',
    value: '',
    filters: {
      new: undefined,
    },
  },
];
